import React from 'react';
import { connect } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

const Hospitalroute = (props) => {
  // const token = window.localStorage.getItem("token");
  // const isLoggedIn = !!token;

  return (
    <>
      {props?.userdata?.role == 'hospital_provider' ? <Outlet /> : <Navigate to="/surveystepone" />}
    </>
  );
};


const mapDispatchToProps = {
}
const mapStateToProps = (state) => {
  return {
    userdata: state.userSession?.sessionData,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Hospitalroute);